<template>
  <div
    :id="id"
    class="modal fade"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    :aria-labelledby="id"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div slot="header">
            <div class="tag-badge">
              <span class="dot text-center">
                <i
                  class="orange-icon orange-icon-badge-align"
                  :class="iconTitle"
                />
              </span>
              <span class="tag-badge-title py-1 pl-2">{{ title }}</span>
            </div>
          </div>

          <div class="col-6 d-flex justify-content-end">
            <span class="close-border p-1 mr-2 mt-0" data-dismiss="modal">
              <i class="fas fa-window-close close-ico" />
              Cerrar
            </span>
          </div>
        </div>
        <div class="modal-body">
          <div class="container">
            <p class="textNorm">
              <slot name="sub-title" />
            </p>
            <div class="table-responsive">
              <table
                class="table content-table-striped content-table-striped-modal"
              >
                <thead
                  class="bg-dark text-white thead-property thead-table-modal table-borderless"
                >
                  <tr class="row">
                    <td class="col-4">
                      <span class="ml-5">{{ columnOneTitle }}</span>
                    </td>
                    <td class="col-6">
                      <span class="ml-5">{{ columnTwoTitle }}</span>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="index">
                    <td>
                      <span class="ml-5">
                        {{ columnOneFormatted(item[columnOneName]) }}
                      </span>
                    </td>
                    <td>
                      <span class="ml-5 pl-40">
                        {{ columnTwoFormatted(item[columnTwoName]) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EvalDiscussion',
  computed: {},
  methods: {
    columnOneFormatted(value) {
      return this.columnOneFormatFn ? this.columnOneFormatFn(value) : value;
    },
    columnTwoFormatted(value) {
      return this.columnTwoFormatFn ? this.columnTwoFormatFn(value) : value;
    },
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    iconTitle: {
      type: String,
      required: true,
    },
    columnOneName: {
      type: String,
      required: true,
    },
    columnOneTitle: {
      type: String,
      required: true,
    },
    columnOneFormatFn: {
      type: Function,
    },
    columnTwoName: {
      type: String,
      required: true,
    },
    columnTwoTitle: {
      type: String,
      required: true,
    },
    columnTwoFormatFn: {
      type: Function,
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.row {
  margin-left: 0px;
  margin-right: 0px;
}

.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.thead-table-modal {
  border-radius: 5px 5px 0px 0px !important;
  display: table-caption;
}

.td-aligned {
  padding-right: 0px;
  padding-left: 32px;
}

.table-h {
  height: 480px;
}
.bg-dark {
  border-collapse: collapse;
  background-color: #3f5b60 !important;
  -webkit-box-shadow: 0px 3px 6px #00000029;
  box-shadow: 0px 3px 6px #00000029;
  opacity: 1;
  color: #ffffff;
  font-weight: 400;
}
.tdDate {
  width: 33.5%;
}

.textNorm {
  font-weight: 400;
}

.content-table-striped-modal {
  margin-top: 0px;
}

.tag-badge {
  display: inline-block;
  padding-right: 1em;
  height: 42px;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  cursor: pointer;
  margin-bottom: 10px;
}

.dot {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: inline-block;
  /* top: 268px; */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 9px;
}
.orange-icon {
  color: #ff7058;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  font: Bold 17px/30px Lato;
  letter-spacing: 0;
  color: #11291b;
  display: inline-block;
}

.close-border {
  border: 1px solid #2db782;
  border-radius: 50px;
  display: inline-block;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.6em;
  text-align: center;
  width: 7.1875rem;
  height: 2.6875‬rem;
  cursor: pointer;
  color: #2db782;
}

.close-ico {
  color: #2db782;
  margin-right: 3px;
}

.modal-header {
  padding: 0.5rem 0rem 0rem 1.5rem;
  box-shadow: 0px 10px 40px -20px black;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
